import { render, staticRenderFns } from "./FormDataAvatar.vue?vue&type=template&id=0247b417&scoped=true&"
import script from "./FormDataAvatar.vue?vue&type=script&lang=js&"
export * from "./FormDataAvatar.vue?vue&type=script&lang=js&"
import style0 from "./FormDataAvatar.vue?vue&type=style&index=0&id=0247b417&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0247b417",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0247b417')) {
      api.createRecord('0247b417', component.options)
    } else {
      api.reload('0247b417', component.options)
    }
    module.hot.accept("./FormDataAvatar.vue?vue&type=template&id=0247b417&scoped=true&", function () {
      api.rerender('0247b417', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/FormDataAvatar.vue"
export default component.exports